
import {
    AnimationActionEnum, SetCoordsAction,
    SetShowHpChangeAction,
    SetShowMiddlewareAction, SetShowPlayUnitHoverAction,
    SetShowUnitADChangeAction,
    SetShowUnitAttackAction
} from "./types";

export const AnimationActionCreators = {
    setShowUnitAttack: (showUnitAttack): SetShowUnitAttackAction => ({
        type: AnimationActionEnum.SET_SHOW_UNIT_ATTACK,
        payload: showUnitAttack
    }),
    setShowMiddleware: (showMiddleware): SetShowMiddlewareAction => ({
        type: AnimationActionEnum.SET_SHOW_MIDDLEWARE,
        payload: showMiddleware
    }),
    setShowHpChange: (showHpChange): SetShowHpChangeAction=> ({
        type: AnimationActionEnum.SET_SHOW_HP_CHANGE,
        payload: showHpChange
    }),
    setShowUnitADChange: (showUnitADChange): SetShowUnitADChangeAction=> ({
        type: AnimationActionEnum.SET_SHOW_UNIT_AD_CHANGE,
        payload: showUnitADChange
    }),
    setShowPlayUnitHover: (showPlayUnitHover): SetShowPlayUnitHoverAction=> ({
        type: AnimationActionEnum.SET_PLAY_UNIT_HOVER,
        payload: showPlayUnitHover
    }),
    setCoords: (coords): SetCoordsAction=> ({
        type: AnimationActionEnum.SET_COORDS,
        payload: coords
    }),
}